import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=f93965d6&scoped=true&"
import script from "./reviewDetail.vue?vue&type=script&lang=js&"
export * from "./reviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./reviewDetail.vue?vue&type=style&index=0&id=f93965d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93965d6",
  null
  
)

export default component.exports